import React from "react";
import styles from "../styles/staticPages.module.scss";

export default function DonationOffer() {
  const contentArr = [
    {
      id: 1,
      title: "Общие положения",
      content: [
        {
          id: 1,
          paragraph:
            "В соответствии с пунктом 2 статьи 437 Гражданского кодекса Российской Федерации данный документ является публичной офертой (далее — «Оферта»).",
        },
        {
          id: 2,
          paragraph:
            "Настоящая Оферта действует с момента её публикации на официальном сайте Благополучателя — ",
          link: "www.donorsearch.org",
          paragraph2: ", а также (или) в личном кабинете Продавца на платформе партнера Фонда — Ozon.",
        },
        {
          id: 3,
          paragraph: "В настоящей Оферте используются следующие термины:",
          list_items: [
            {
              id: 1,
              strong: "Пожертвование",
              paragraph: " — добровольное дарение денежных средств или иного имущества в общеполезных целях, предусмотренных уставом Благополучателя, в соответствии со статьей 582 Гражданского кодекса Российской Федерации.",
            },
            {
              id: 2,
              strong: "Благотворитель",
              paragraph: " — физическое или юридическое лицо, выразившее согласие с условиями настоящей Оферты и совершившее действия, направленные на перечисление Пожертвования в пользу Благополучателя.",
            },
            {
              id: 3,
              strong: "Благополучатель",
              paragraph: " — Автономная некоммерческая организация \"Институт развития донорства \"Донор-Сёрч (Поиск доноров)\", получающая Пожертвование в соответствии с условиями настоящей Оферты.",
            },
            {
              id: 4,
              paragraph: "Термины «Личный кабинет», «Платформа», «Продавец», «Ozon» и их значения указаны в Договоре для продавцов на Платформе Ozon, размещенном по адресу: ",
              link: "https://seller-edu.ozon.ru/contract-for-sellers/contract-goods/contract-for-sell-goods-on-ozon",
            },
          ],
        },
        {
          id: 4,
          paragraph: "Благополучатель вправе в любое время внести изменения в Оферту либо отозвать ее, разместив соответствующую информацию на вышеуказанном сайте.",
        },
      ],
    },
    {
      id: 2,
      title: "Предмет договора",
      content: [
        {
          id: 1,
          paragraph: "По настоящей Оферте Благотворитель добровольно передает Благополучателю денежные средства в качестве благотворительного пожертвования, а Благополучатель принимает их для осуществления уставной деятельности и содержания организации.",
        },
        {
          id: 2,
          paragraph: "Благотворитель вправе определить размер пожертвования самостоятельно.",
        },
      ],
    },
    {
      id: 3,
      title: "Порядок акцепта Оферты и заключения договора",
      content: [
        {
          id: 1,
          paragraph: "Акцептом настоящей Оферты признается совершение Благотворителем любого из следующих действий:",
          list_items: [
            {
              id: 1,
              paragraph: "Перечисление денежных средств на расчетный счет Благополучателя с указанием в назначении платежа: «пожертвование на уставную деятельность»;",
            },
            {
              id: 2,
              paragraph: "Оплата с использованием банковских карт, электронных платежных систем, а также других технических средств, доступных на сайте или партнерской платформе;",
            },
            {
              id: 3,
              paragraph: "Передача пожертвования через агента, действующего от имени Благотворителя, в том числе через платформу Ozon.",
            },
          ],
        },
        {
          id: 2,
          paragraph: "Получение денежных средств от агента Благотворителя признается надлежащим способом передачи пожертвования и акцептом Оферты.",
        },
        {
          id: 3,
          paragraph: "Дата поступления пожертвования на счет Благополучателя считается датой заключения договора.",
        },
      ],
    },
    {
      id: 4,
      title: "Отказ от пожертвований и возврат средств",
      content: [
        {
          id: 1,
          paragraph: "Благотворитель вправе отказаться от последующих регулярных пожертвований через форму отмены, доступную по ссылке: ",
          link: "https://my.cloudpayments.ru/",
        },
        {
          id: 2,
          paragraph: "Возврат ранее переданных средств возможен исключительно при наличии доказательств использования пожертвования не по назначению, в соответствии с положениями статьи 582 ГК РФ и условий настоящей Оферты.",
        },
      ],
    },
    {
      id: 5,
      title: "Заключительные положения",
      content: [
        {
          id: 1,
          paragraph: "Совершая акцепт Оферты, Благотворитель подтверждает свое ознакомление с ее условиями, а также с уставными целями Благополучателя, осознает значение своих действий, имеет все права и полномочия для их совершения, и полностью принимает условия настоящей Оферты.",
        },
        {
          id: 2,
          paragraph: "Оферта регулируется и толкуется в соответствии с законодательством Российской Федерации.",
        },
      ],
    },
    {
      id: 6,
      title: "Реквизиты Благополучателя",
      noNumbering: true,
      content: [
        {
          id: 1,
          paragraph: "Автономная некоммерческая организация \"Институт развития донорства \"Донор-Сёрч (Поиск доноров)\"",
        },
        {
          id: 2,
          paragraph: "ИНН 1686035415",
        },
        {
          id: 3,
          paragraph: "КПП 168601001",
        },
        {
          id: 4,
          paragraph: "ОГРН 1241600003677",
        },
        {
          id: 5,
          paragraph: "Адрес места нахождения: 420061, Казань, ул. Сеченова, д.5 офис 2",
        },
        {
          id: 6,
          paragraph: "Банковские реквизиты:",
        },
        {
          id: 7,
          paragraph: "Номер банковского счёта: 40703810720000001947",
        },
        {
          id: 8,
          paragraph: "Банк: ООО \"Банк Точка\"",
        },
        {
          id: 9,
          paragraph: "БИК: 044525104",
        },
        {
          id: 10,
          paragraph: "Номер корреспондентского счёта банка: 30101810745374525104",
        },
        {
          id: 11,
          paragraph: "Директор",
        },
        {
          id: 12,
          paragraph: "Шекуров Руслан Петрович",
        },
      ],
    },
  ];

  return (
    <div className={styles.newHow}>
      <div className={"container"}>
        <div className={styles.newHow_Div}>
          <div className={styles.newHow_Div_BlockTitle}>
            <h1 className={"mb-4"} style={{ "overflowWrap": "break-word" }}>Публичная оферта о заключении договора пожертвования</h1>
            <p>Автономная некоммерческая организация "Институт развития донорства "Донор-Сёрч (Поиск доноров)", в лице директора Шекурова Руслана Петровича, действующего на основании Устава (далее — «Благополучатель»), настоящим предлагает любому физическому и/или юридическому лицу, отвечающему требованиям настоящей Оферты и выразившему готовность сделать пожертвование (далее — «Благотворитель»), заключить договор добровольного благотворительного пожертвования на следующих условиях:</p>
          </div>
          {contentArr.map((item) => (
            <div key={item.id}>
              <p dir="ltr">
                <br />
              </p>
              <p dir="ltr">
                <strong>{item.id}. </strong>
                <strong>{item.title}</strong>
              </p>
              {item.content.map((el) => (
                <div key={el.id}>
                  <div dir="ltr" style={{ "marginLeft": "5%", "marginBottom": "15px" }}>
                    {!item.noNumbering && <strong>{`${item.id}.${el.id}.`}</strong>}
                    {el.strong && <strong>{el.strong} – </strong>}
                    {`${el.paragraph}`}
                    {el.link && <a href={el.link.startsWith('https') ? el.link : `https://${el.link}`}>{el.link}</a>}
                    {el.paragraph2}
                    {el.list_items && (
                      <ul>
                        {el.list_items.map((li) => (
                          <li key={li.id} style={{ "marginLeft": "7%" }}>
                            {li.strong && <strong>{li.strong}</strong>}
                            {li.paragraph}
                            {li.link && <a href={li.link}>{li.link}</a>}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}